import { render, staticRenderFns } from "./BaseMultipleInputFile.vue?vue&type=template&id=4a2d87cc&scoped=true&"
import script from "./BaseMultipleInputFile.vue?vue&type=script&lang=js&"
export * from "./BaseMultipleInputFile.vue?vue&type=script&lang=js&"
import style0 from "./BaseMultipleInputFile.vue?vue&type=style&index=0&id=4a2d87cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2d87cc",
  null
  
)

export default component.exports